
<template>

    <article class="hover-effect-2 card tile-card">

        <div class="preview-icons">
            <div v-if="blog.youtube" title="YouTube video">
                <i class="fal fa-play-circle"></i>
            </div>
            <div v-if="blog.template === 'Gallery'" title="Gallery images">
                <i class="fal fa-images"></i>
            </div>
        </div>


        <div class="overlay"></div>

        <img v-if="blog.image" :src="tileImage" :alt="blog.image.title" class="img-fluid">

        <div class="excerpt">

            <span class="collection text-uppercase" v-for="col in blog.collections">{{ col.title }}</span>

            <h3>{{blog.title}}</h3>

            <p>
                {{blog.excerpt}}
            </p>

        </div>

        <a :href="(blog.seo.redirect_url ? blog.seo.redirect_url : '/blog/' + blog.uri)" class="link"></a>

    </article>

</template>


<script>

    export default {
        props: ["blog"],
		data () {
			return {

				tileImage: ""
			}
		},
		mounted: function() {

        	let handle = this;

        	jQuery(document).ready(function() {

				if(window.tileCardWidth === null || typeof window.tileCardWidth === "undefined") {

					let node = document.querySelector(".tile-card");
					window.tileCardWidth = node.offsetWidth;
				}

				handle.tileImage = handle.displayImage(handle.blog.image, window.tileCardWidth);

			});
		}
    }

</script>



// WEBPACK FOOTER //
// src/snippets/blog/Tile.vue